import { render, staticRenderFns } from "./welfareroll.vue?vue&type=template&id=0fa7fa93&scoped=true&"
import script from "./welfareroll.vue?vue&type=script&lang=js&"
export * from "./welfareroll.vue?vue&type=script&lang=js&"
import style0 from "./welfareroll.vue?vue&type=style&index=0&id=0fa7fa93&scoped=%20scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa7fa93",
  null
  
)

export default component.exports